module.exports = __webpack_public_path__ + "img/three.7f93ca22.png";